import { isCartWebPage } from '../../client/hooks/UrlManager/pageTypeService';

const CLUB_BUSINESS_ORIGIN_CLUB_PARAM_KEY = 'businessOrigin';
const CLUB_BUSINESS_ORIGIN_CLUB_PARAM_VALUE = 'club';

export function shouldShowClubHeader(url: URL) {
    const { pathname, searchParams } = url;
    return (
        isCartWebPage(pathname) &&
        searchParams.get(CLUB_BUSINESS_ORIGIN_CLUB_PARAM_KEY) === CLUB_BUSINESS_ORIGIN_CLUB_PARAM_VALUE
    );
}
